import React, { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './ScrollContainer.scss';
var ScrollContainer = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.scrollContainer, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.scrollContainerInner,
    ref: ref
  }, children));
});
export default ScrollContainer;